var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2868 0H2.71445C1.21739 0 0 1.21699 0 2.71582V19.785C0 21.282 1.21739 22.4977 2.71445 22.4977H21.2868C22.7838 22.4977 23.9999 21.282 23.9999 19.785V2.71582C24 1.21699 22.7839 0 21.2868 0ZM15.5196 4.03894C16.9673 4.03894 18.1414 5.21311 18.1414 6.66076C18.1414 8.10841 16.9673 9.28258 15.5196 9.28258C14.0715 9.28258 12.8978 8.10841 12.8978 6.66076C12.8978 5.21311 14.0715 4.03894 15.5196 4.03894ZM20.4356 19.9885H3.9398C3.21569 19.9885 2.89321 19.4646 3.21963 18.8183L7.71916 9.90618C8.04518 9.25992 8.66653 9.20224 9.10655 9.77723L13.631 15.6899C14.071 16.265 14.8401 16.3139 15.3491 15.7987L16.456 14.6779C16.9646 14.1627 17.714 14.2265 18.1291 14.8195L20.9953 18.9135C21.4096 19.5074 21.1597 19.9885 20.4356 19.9885Z",
    fill: "url(#paint0_linear_1617_97522)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1617_97522",
    x1: 20.6667,
    y1: 1.40611,
    x2: 8.53547,
    y2: 27.0105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4336"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.c0cab48e630fbc3d5a01b48d8168a9f9.svg";
export { ForwardRef as ReactComponent };